import { Editor } from '@tinymce/tinymce-react';

const TinyMceEditor = ({ input, value, onChange, height = 500, toolbar, init = {} }) => {
    const editorValue = input ? input.value : value;
    const handleChange = input ? input.onChange : onChange;

    return (
        <Editor
            apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
            value={editorValue || ''}
            onEditorChange={handleChange}
            init={{
                height,
                plugins: [
                    "advlist", "autolink", "lists", "link", "charmap",
                    "preview", "anchor", "searchreplace", "visualblocks",
                    "code", "fullscreen", "insertdatetime", "media",
                    "table", "help", "wordcount", "paste"
                ],
                toolbar: toolbar || 'undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | ' + 'bullist numlist outdent indent | link image | print preview media fullscreen | ' +
                    'forecolor backcolor emoticons | help',
                menu: {
                    favs: { title: 'My Favorites', items: 'code visualaid | searchreplace | emoticons' }
                },
                menubar: 'favs file edit view insert format tools table help',
                content_css: 'css/content.css',
                branding: false,
                ...init,
            }}
        />
    );
};

export default TinyMceEditor;
